// extracted by mini-css-extract-plugin
module.exports = {"base":"0","xs":"576","sm":"767","md":"991","lg":"1200","xl":"1365","xxl":"1535","xxxl":"1800","fhd":"2160","qhd":"2560","kkk":"2880","uwqhd":"3440","kkkk":"3840"};